/**
 * httpリクエスト処理
 */

import common from '@/mixin/common'
import * as constants from '@/mixin/constants'
// Ajax通信ライブラリ
import 'whatwg-fetch'

const URL = ''

export default {
  created: function () {
    this.URL = process.env.WEB_API_ORIGIN + "/rosettaapi/"
  },
  mixins: [
    common,
  ],
  methods: {
    /**
     * API送信用のスコアデータを作成
     */
    createScoreDataForApi: function(levelNo, unitNo, lessonIndex, pathIndex, pathstepIndex, ok, ng, skip) {
      var res = []

      var key = constants.DATA_SCORE + levelNo + '-' + unitNo + '-' + lessonIndex + '-' + pathIndex + '-' + pathstepIndex
      var okVal = '{"' + key + '-ok":"' + ok + '"}'
      var ngVal = '{"' + key + '-ng":"' + ng + '"}'
      var skipVal = '{"' + key + '-skip":"' + skip + '"}'

      res.push(okVal)
      res.push(ngVal)
      res.push(skipVal)

      return res.toString()
    },
    /**
     * リセットするためのAPI送信用のスコアデータを作成
     */
    createResetScoreDataForApi: function(levelNo, unitNo, lessonIndex, pathIndex, pathstepLen) {
      var res = []

      for(var i=0; i < pathstepLen; i++) {
        var key = constants.DATA_SCORE + levelNo + '-' + unitNo + '-' + lessonIndex + '-' + pathIndex + '-' + i
        var okVal = '{"' + key + '-ok":"0"}'
        var ngVal = '{"' + key + '-ng":"0"}'
        var skipVal = '{"' + key + '-skip":"0"}'

        res.push(okVal)
        res.push(ngVal)
        res.push(skipVal)
      }

      return res.toString()
    },
    /**
     * API送信用の進捗データを作成
     */
    createProgressDataForApi: function(levelNo, unitNo, lessonIndex, pathIndex, pathstepIndex) {
      var key = constants.DATA_PROGRESS + levelNo + '-' + unitNo + '-' + lessonIndex + '-' + pathIndex
      var val = '{"' + key + '":"' + pathstepIndex + '"}'
      return val
    },
    /**
     * API送信用のマイルストーンデータを作成
     */
    createMilestoneDataForApi: function(levelNo, unitNo, milestoneData) {
      var res = []

      for(var i=0; i < milestoneData.length; i++) {
        var key = constants.DATA_MILESTONE + levelNo + '-' + unitNo + '-' + i
        var val = '{"' + key + '":"' + milestoneData[i] + '"}'
        res.push(val)
      }

      return res.toString()
    },
    /**
     * API送信用の学習状態データを作成
     */
    createStudyStatusDataForApi: function(studying) {
      var val = '{"' + constants.DATA_STUDY_STATE + '":"' + studying + '"}'
      return val
    },
    /**
     * HTTPリクエスト
     *
     * @param {string} path URL拡張パス
     * @param {string} method HTTPメソッド
     * @param {string} param リクエストパラメータ
     * @param {string} accessKey アクセスキー(未指定可)
     */
    request: function(path, method, param, accessKey) {
      var self = this
      var headers = { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' }

      // アクセスキー設定
      if (accessKey) {
        headers['X-RS-Access-Key'] = accessKey
      }

      // fetchオプションの設定
      var options = {
        method: method,
        mode: 'cors',
        credentials: 'include',
        headers: headers,
      }

      // リクエストパラメータ
      if (param) {
        options.body = param
      }

      // リクエスト実行
      return new Promise(function(resolve, reject) {
        fetch(self.URL + path, options)
          .then (function(response) {
            self.log(path + " response.status: " + response.status)
            if(response.status != 200) {
              reject(response.status)
            }

            resolve(response.json())
          })
          .catch (function(error) {
            self.log(path + " error: " +　error)
            reject('')
          })
      })
    },
    /**
     * HTTPリクエスト(アクセスキー付与)
     *
     * @param {string} path URL拡張パス
     * @param {string} method HTTPメソッド
     * @param {string} param リクエストパラメータ
     * @param {string} accessKey アクセスキー(未指定可)
     */
    requestWithAccessKey: async function(path, method, param, accessKey) {
      // アクセスキーが指定されなかった場合、ここで取得
      var key = accessKey
      if (!key) {
        key = await storage_wrapper.getRsAccessKey()
      }
      // HTTPリクエスト
      return this.request(path, method, param, key)
    },
    /**
     * ログインAPI
     *
     * @param {string} email メールアドレス
     * @param {string} password パスワード
     */
    login: function(email, password) {
      this.log("http start login")
      // 入力パラメータの設定
      var param = 'email=' + encodeURIComponent(email) + '&password=' + password
      // HTTPリクエスト
      return this.request('login', 'POST', param)
    },
    /**
     * シリアル入力API
     *
     * @param {string} contentid コンテンツID
     * @param {string} serial シリアル
     * @param {string} accessKey アクセスキー(未指定可)
     */
    activate: function(contentid, serial, accessKey) {
      this.log("http start activate")
      // 入力パラメータの設定
      var param = 'contentid=' + contentid + '&serial=' + serial
      // HTTPリクエスト
      return this.requestWithAccessKey('activate', 'POST', param, accessKey)
    },
    /**
     * ライセンスチェックAPI
     *
     * @param {string} contentid コンテンツID
     * @param {string} accessKey アクセスキー(未指定可)
     */
    checkLicense: function(contentid, accessKey) {
      this.log("http start checkLicense")
      // 入力パラメータの設定
      var param = 'contentid=' + contentid
      // HTTPリクエスト
      return this.requestWithAccessKey('checklicense', 'POST', param, accessKey)
    },
    /**
     * key-value取得API
     *
     * @param {string} contentid コンテンツID
     * @param {string} keyname
     * @param {string} accessKey アクセスキー(未指定可)
     */
    getKeyValue: function(contentid, keyname, accessKey) {
      this.log("http start getKeyValue keyname: " + keyname)
      // 入力パラメータの設定
      var param = 'contentid=' + contentid + '&keyname=' + keyname
      // HTTPリクエスト
      return this.requestWithAccessKey('getkeyvalue', 'POST', param, accessKey)
    },
    /**
     * key-value設定API
     *
     * @param {string} contentid コンテンツID
     * @param {string} datajson
     * @param {string} accessKey アクセスキー(未指定可)
     */
    setKeyValue: function(contentid, datajson, accessKey) {
      this.log("http start setKeyValue")
      // 入力パラメータの設定
      var param = 'contentid=' + contentid + '&datajson=' + datajson
      // HTTPリクエスト
      return this.requestWithAccessKey('setkeyvalue', 'POST', param, accessKey)
    },
    /**
     * ログアウトAPI
     */
    logout: function () {
      this.log("http start logout")
      // HTTPリクエスト
      return this.requestWithAccessKey('logout', 'GET')
    },
    /**
     * アクセスキー取得API
     *
     * @param {string} onetimekey ワンタイムキー
     * @param {string} accessKey アクセスキー(未指定可)
     */
    getAccessKey: function (oneTimeKey, accessKey) {
      this.log("http start getAccessKey")
      // 入力パラメータの設定
      var param = 'onetimekey=' + oneTimeKey
      // HTTPリクエスト
      return this.request('getaccesskey', 'POST', param, accessKey)
    },
    /**
     * 進捗率設定API
     *
     * @param {string} contentid コンテンツID
     * @param {string} progress 進捗率
     * @param {string} accessKey アクセスキー(未指定可)
     */
    registerProgress: function (contentid, progress, accessKey) {
      this.log("http start registerProgress")
      // 入力パラメータの設定
      var param = 'contentid=' + contentid + '&progress=' + progress
      // HTTPリクエスト
      return this.requestWithAccessKey('registerprogress', 'POST', param, accessKey)
    },
  },
}



// WEBPACK FOOTER //
// ./src/mixin/http.js